import { render, staticRenderFns } from "./UserSettingsFields.vue?vue&type=template&id=2e18138f&scoped=true&"
import script from "./UserSettingsFields.vue?vue&type=script&lang=js&"
export * from "./UserSettingsFields.vue?vue&type=script&lang=js&"
import style0 from "./UserSettingsFields.vue?vue&type=style&index=0&id=2e18138f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e18138f",
  null
  
)

export default component.exports